import { filterClusters, filterHealthStats, filterNames } from 'utils/filters';
import { GOOGLE_METADATA_BY_KEY } from 'utils/metrics';
import GoogleRelatedSectionTable from './GoogleRelatedTable/GoogleRelatedSectionTable';
import { createDefaultColumns } from './DataTable/utils';

function BrandsTable({
    categoryId,
    countryId,
    controller = null,
    handleFilter = {
        cluster: filterClusters,
        healthStats: filterHealthStats,
        name: filterNames,
    },
    getColumnsConfig = (visibleOrderedMetrics) => {
        const columnsConfig = createDefaultColumns([
            'name',
            GOOGLE_METADATA_BY_KEY.price_segmentation,
            ...visibleOrderedMetrics,
        ]);
        return columnsConfig;
    },
    sortParamKey,
    ...restProps
}) {
    return (
        <GoogleRelatedSectionTable
            icon="brand"
            paginateBy="brands"
            categories={categoryId}
            countries={countryId}
            controller={controller}
            handleFilter={handleFilter}
            getColumnsConfig={getColumnsConfig}
            sortParamKey={sortParamKey}
            {...restProps}
        />
    );
}

export default BrandsTable;
